import * as Sentry from "@sentry/react";
import { getAuthToken } from "../utils/storageService";

const API_URL = import.meta.env.VITE_API_URL;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function fetchJson<Data = any>(
  url: string,
  options: RequestInit = {},
): Promise<Data> {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}${url}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  if (!response.ok) {
    const error = new Error(`Network response was not ok: ${response.status}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error as any).status = response.status;
    if (response.status >= 500) {
      Sentry.captureException(error);
    }

    if (response.status === 404) {
      if (window.location.pathname !== "/404") {
        window.location.href = "/404";
      }
      return null as Data;
    }

    throw error;
  }
  return await response.json();
}
